export class Method {
    func: any;

    cnt: Container;

    constructor(cnt: Container, fu: any) {
        this.func = fu;

        this.cnt = cnt;
    }
}

export class Container {
    group: Group;

    funcs: any;

    key: string;

    constructor(group: Group, key: string) {
        this.group = group;
        this.funcs = [];
        this.key = key;
    }

    registerFunc(name: string, cnt: any) {
        this.funcs[name] = new Method(this, cnt);
    }

    getFunction(name: string): Method | null {
        if (this.funcs[name]) {
            return this.funcs[name];
        } else {
            return null;
        }
    }
}

export class Group {
    key: string;

    funcs: any;

    groups: any;

    containers: any;

    constructor(key: string) {
        this.key = key;
        this.groups = {};
        this.funcs = {};
        this.containers = {};
    }

    container(key: string): Container {
        if (this.containers[key]) {
            return this.containers[key];
        } else {
            let container = new Container(this, key);
            this.containers[key] = container;
            return container;
        }
    }

    group(key: string): Group {
        if (this.groups[key]) {
            return this.groups[key];
        } else {
            let group = new Group(key);
            this.groups[key] = group;
            return group;
        }
    }

    search(parts: string[]): Method | null {
        if (parts.length == 2) {
            let container = this.containers[parts[0]];
            if (container != null) {
                let func = container.getFunction(parts[1]);
                if (func != null) {
                    return func;
                }
            } else {
            }
        } else {
            let group = this.groups[parts[0]];
            if (group != null) {
                return group.search(parts.slice(1));
            }
        }
        return null;
    }
}

export class Registry {
    groups: any;

    containers: any;

    constructor() {
        this.groups = {};
        this.containers = {};
    }

    group(key: string): Group {
        if (this.groups[key]) {
            return this.groups[key];
        } else {
            let group = new Group(key);
            this.groups[key] = group;
            return group;
        }
    }

    search(parts: string[]): Method | null {
        if (parts.length == 2) {
            let container = this.containers[parts[0]];
            if (container != null) {
                let func = container.getFunction(parts[1]);
                if (func != null) {
                    return func;
                } else {
                    return null;
                }
            }
        } else {
            let group = this.groups[parts[0]];
            if (group != null) {
                return group.search(parts.slice(1));
            } else {
            }
        }
        return null;
    }
}
